import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule } from '@angular/forms';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcColumnTypeModule } from '@datachain/ui-sdk/components/app-column-type';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import { DcNavigateDirectiveModule } from '@datachain/ui-sdk/directives';
import { DcArrayPipeModule, DcValuePipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
	DxButtonModule,
	DxCheckBoxModule,
	DxDataGridModule,
	DxSelectBoxModule,
} from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { FormulaActionPopupComponent } from './components/formula-action-popup/formula-action-popup.component';
import { FormulaListComponent } from './components/formula-list/formula-list.component';
import { FormulaUsageDetailsComponent } from './components/formula-usage-details/formula-usage-details.component';
import { FormulaUsageListComponent } from './components/formula-usage-list/formula-usage-list.component';
import { FormulaParser } from './formula.parser';
import { FormulaEffects } from './store/formula.effects';
import { formulaReducer } from './store/formula.reducer';
import { FormulaSelector } from './store/formula.selector';
import { FormulaState } from './store/formula.state';

@NgModule({
	declarations: [
		FormulaUsageListComponent,
		FormulaUsageDetailsComponent,
		FormulaListComponent,
		FormulaActionPopupComponent,
	],
	imports: [
		CommonModule,
		UiModule,
		DcPageModule,
		DcArrayPipeModule,
		DcValuePipeModule,
		MaterialModule,
		StoreModule.forFeature(FormulaState.key, formulaReducer),
		EffectsModule.forFeature([FormulaEffects]),
		DxDataGridModule,
		DxCheckBoxModule,
		DxSelectBoxModule,
		DxButtonModule,
		FormsModule,
		DcPanelModule,
		DcColumnTypeModule,
		DcAvatarModule,
		DcBadgeModule,
		DcNavigateDirectiveModule,
		DcBreadcrumbModule,
		DcButtonModule,
	],
	providers: [FormulaSelector, FormulaParser],
})
export class FormulaModule {
	public constructor(private readonly injector: Injector) {
		const formulasUsageListCmpElement = createCustomElement(
			FormulaUsageListComponent,
			{
				injector,
			}
		);
		customElements.define(
			'app-formulas-usage-list',
			formulasUsageListCmpElement
		);

		const formulaListCmpElement = createCustomElement(FormulaListComponent, {
			injector,
		});
		customElements.define('app-formula-list', formulaListCmpElement);
	}
}
